/* eslint-disable import/prefer-default-export */
import { CustomHostIdRebuildState } from "../../models/companySettings/customHostIdRebuildState";
import { CustomHostIdSettings } from "../../models/companySettings/customHostIdSettings";

// Returns true if the custom host Id is currently being rebuilt or requires a rebuild
export const isCustomHostIdBuilding = (settings: CustomHostIdSettings): boolean =>
  settings.rebuildState === CustomHostIdRebuildState.QueuedForRebuild ||
  settings.rebuildState === CustomHostIdRebuildState.Rebuilding;
